export default "__VITE_ASSET__a62ce47b__"